export default __webpack_public_path__ + "statics/fonts/Workbench[wdth,wght].woff2";